import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getContractorAssignBookingList = createAsyncThunk(
  "contractorAssignBookingList/getContractorAssignBookingList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/contractor/assign_contractor_to_booking`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const contractorAssignBookingSlice = createSlice({
  name: "contractorAssignBookingList",
  initialState: {
    loading: false,
    contractorAssignBookingData: null,
    error: null,
  },
  reducers: {
    ResetAcceptJob: (state) => {
      state.contractorAssignBookingData = null; // Clear old data
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContractorAssignBookingList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getContractorAssignBookingList.fulfilled, (state, action) => {
        state.loading = false;
        state.contractorAssignBookingData = action.payload;
      })
      .addCase(getContractorAssignBookingList.rejected, (state, action) => {
        state.loading = false;
        state.contractorAssignBookingData = action.payload;
        state.error = action.payload;
      });
  },
});
export const { ResetAcceptJob } = contractorAssignBookingSlice.actions;
export default contractorAssignBookingSlice.reducer;
